import { AxiosPromise } from 'axios';
import { IAltenarSession } from '../model/altenar-service.types';
import {api} from "../../../shared/api";

export const createAltenarSession: () => AxiosPromise<IAltenarSession> = () =>
  api.get('/json-rpc/create-session/altenar');
